import { createUTCDate } from 'app/infrastructure/data/date';

/**
 * Creates favourite condition for date filter
 * 
 * @param value UTC date
 */
export const createDateFieldCondition = (value: Date) => ({
  date: !value ? value : createUTCDate({
    year: value.getUTCFullYear(), month: value.getUTCMonth(), day: value.getUTCDate(),
    hours: 0, minutes: 0, seconds: 0, milliseconds: 0
  })
});
